export default __webpack_public_path__ + "static/media/welcome-orange.ffdfbf1a.svg";